export const dropdowndata = [
    {value: 'Both Part Exists(PartA & PartB)', label: 'Both Part Exists(PartA & PartB)'},
    {value: 'Slip Number Matched', label: 'Slip Number Matched'},
    {value: 'Amount Matched', label: 'Amount Matched'}
]